import axios from "axios";
import { parseError } from "./lib";
import { authTokenName } from "../../../../entities/authTokenName";

export const remove = async (mainPath, path, params, headers = {}, defaultHeadersParam = true) => {

  const defaultHeaders = {Authorization:sessionStorage.getItem(authTokenName), Accept:"application/ld+json"}
  const resultHeaders = defaultHeadersParam ? {...headers,...defaultHeaders}:headers

  try {
    const requestResponse = await axios.delete(mainPath + path, {
      params,
      headers:resultHeaders,
    });

    return requestResponse.data;
  } catch (err) {
    return parseError(err);
  }
};
